import schemas from 'components/forms/fields/definedSchemas';

const reasonOptions = [
    'Had difficulty navigating site',
    'No longer need MMC help',
    'Getting MMC help from another provider',
    'Wanted to temporarily pause my account',
    'Billing Confusion',
    'Too expensive / can no longer afford',
    'Technical Issues',
    "Didn't have the features I was looking for",
];

const fields = {
    reason_for_leaving: {
        ...schemas.radioWithWritin,
        section: 'Unsubscribe',
        options: Object.fromEntries(reasonOptions.map(item => [item, item])),
        validation: schemas.radioWithWritin.validation.allow('', null),
    },
};

export default fields;
